import { createContext } from "react";
import { ToastProps } from "flux";

export interface ToastAction {
  label: string;
  onClick: () => Promise<void>;
}
export interface ToastContextType {
  openToast: (message: string, action?: ToastAction, options?: ToastProps) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);
export default ToastContext;
